import { render, staticRenderFns } from "./feeItem.vue?vue&type=template&id=6b5b9852&"
import script from "./feeItem.vue?vue&type=script&lang=js&"
export * from "./feeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports